import { render, staticRenderFns } from "./inventory.vue?vue&type=template&id=2ae0a439"
import script from "./inventory.vue?vue&type=script&lang=js"
export * from "./inventory.vue?vue&type=script&lang=js"
import style0 from "./inventory.vue?vue&type=style&index=0&id=2ae0a439&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports